import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, AlertCircle } from "lucide-react";
import { getPaymentStatus } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) {
      setState("error");
      return;
    }
    let attempts = 0;
    let timer;
    const poll = async () => {
      try {
        const data = await getPaymentStatus(sessionId);
        if (data.payment_status === "paid") {
          setState("paid");
          return;
        }
      } catch (e) {
        // keep polling briefly
      }
      attempts += 1;
      if (attempts < 8) timer = setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page" className="flex min-h-screen items-center justify-center bg-purple-50/50 px-5">
      <div className="w-full max-w-md rounded-3xl border border-purple-100 bg-white p-10 text-center shadow-2xl shadow-purple-600/10">
        {state === "checking" && (
          <>
            <Loader2 className="mx-auto h-12 w-12 animate-spin text-purple-600" />
            <h1 className="mt-6 font-heading text-2xl font-bold text-slate-900">Stiamo confermando il pagamento...</h1>
            <p className="mt-2 text-sm text-slate-500">Qualche secondo e ci siamo.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 data-testid="payment-confirmed-icon" className="mx-auto h-14 w-14 text-purple-600" />
            <h1 className="mt-6 font-heading text-2xl font-bold text-slate-900">Benvenuto in MIR-IA!</h1>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              Pagamento confermato! Scarica l'app MIR-IA, tocca «Ho già pagato, attiva il mio account» e usa la{" "}
              <strong>stessa email del pagamento</strong>.
            </p>
          </>
        )}
        {state === "pending" && (
          <>
            <AlertCircle className="mx-auto h-12 w-12 text-amber-500" />
            <h1 className="mt-6 font-heading text-2xl font-bold text-slate-900">Pagamento in elaborazione</h1>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              Abbiamo ricevuto la richiesta: riceverai una email di conferma appena Stripe completa la transazione.
            </p>
          </>
        )}
        {state === "error" && (
          <>
            <AlertCircle className="mx-auto h-12 w-12 text-red-500" />
            <h1 className="mt-6 font-heading text-2xl font-bold text-slate-900">Sessione non trovata</h1>
            <p className="mt-3 text-sm text-slate-600">Se hai completato il pagamento, contattaci e verifichiamo subito.</p>
          </>
        )}
        <Link
          to="/"
          data-testid="back-home-link"
          className="mt-8 inline-block rounded-full bg-purple-600 px-8 py-3 font-heading text-sm font-bold text-white transition-colors hover:bg-purple-700"
        >
          Torna alla home
        </Link>
      </div>
    </div>
  );
}
